import React from "react";
import s from "./ProductPackages/ProductPackages.module.scss";
import CheckBox from "@children/assets/svg/CheckBox";
import CheckBoxChecked from "@children/assets/svg/CheckBoxChecked";

const ProductSelectorButton = ({ isChecked }) => {
  return <div className={s.buttonContainer}>{isChecked ? <CheckBoxChecked /> : <CheckBox />}</div>;
};

export default ProductSelectorButton;
